import React from 'react';
import Form from "react-bootstrap/Form";

const OthersInfoForm = ({fields, handleFieldChange, messages, page, isTransfer}) => {
  return (
    <>
      <h3>その他入力欄</h3>
      <dl>
        <dt>略歴<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="biography">
            <Form.Control
              as="textarea"
              value={fields.biography}
              onChange={handleFieldChange}
              rows={3}
            />
          </Form.Group>
          <p id="biographyMessage" className="errorMessages">{messages.biography.n}</p>
        </dd>
        <dt>スポーツ現場に関わる活動<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="activitiesForTheField">
            <Form.Control
              as="textarea"
              value={fields.activitiesForTheField}
              onChange={handleFieldChange}
              rows={3}
            />
          </Form.Group>
          <p>現在までのスポーツ現場に関わる活動について具体的にご記入下さい。</p>
          <p id="activitiesForTheFieldMessage" className="errorMessages">{messages.activitiesForTheField.n}</p>
        </dd>
        <dt>原著論文・学会発表歴<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="papersAndPerformanceHistory">
            <Form.Control
              as="textarea"
              value={fields.papersAndPerformanceHistory}
              onChange={handleFieldChange}
              rows={3}
            />
          </Form.Group>
          <p>これまで学術誌に掲載された原著論文や学会発表歴がありましたら具体的にご記入下さい。</p>
          <p id="papersAndPerformanceHistoryMessage" className="errorMessages">{messages.papersAndPerformanceHistory.n}</p>
        </dd>
        <dt style={ isTransfer ? {'display': 'none'} : {} }>入会希望の動機と抱負<span className="red">*</span></dt>
        <dd style={ isTransfer ? {'display': 'none'} : {} }>
          <Form.Group controlId="motivationsAndAspirations">
            <Form.Control
              as="textarea"
              value={fields.motivationsAndAspirations}
              onChange={handleFieldChange}
              rows={3}
            />
          </Form.Group>
          <p>入会希望の動機と抱負をご記入下さい。</p>
          <p id="motivationsAndAspirationsMessage" className="errorMessages">{messages.motivationsAndAspirations.n}</p>
        </dd>
      </dl>
    </>

  );
}

export default OthersInfoForm;
